import { CALYPSO_DARK, OLAF, SLINKY } from 'visitor-ui-component-library/constants/WidgetColors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "GeneratingIndicator__Wrapper",
  componentId: "pyj1mc-0"
})(["display:flex;align-items:center;gap:4px;"]);
const ripple = keyframes(["0%{scale:0;opacity:0;}4.9%{opacity:0;scale:0;}5%{scale:0;opacity:1;}100%{scale:.75;opacity:0;}"]);
const Ripple = styled.div.withConfig({
  displayName: "GeneratingIndicator__Ripple",
  componentId: "pyj1mc-1"
})(["width:16px;height:16px;position:relative;flex:0 0 auto;border-radius:50%;background-color:", ";> div{position:absolute;width:100%;height:100%;top:0;left:0;border:2px solid ", ";opacity:1;border-radius:50%;animation:", " 1.5s cubic-bezier(0,0.2,0.8,1) infinite;transform-origin:50% 50%;}> div:nth-child(2){animation-delay:-0.75s;}"], CALYPSO_DARK, OLAF, ripple);
const Description = styled.div.withConfig({
  displayName: "GeneratingIndicator__Description",
  componentId: "pyj1mc-2"
})(["font-size:12px;color:", ";"], SLINKY);
export default function GeneratingIndicator({
  children
}) {
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(Ripple, {
      children: [/*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx("div", {})]
    }), /*#__PURE__*/_jsx(Description, {
      children: children || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.generatingMessage"
      })
    })]
  });
}
GeneratingIndicator.displayName = 'GeneratingIndicator';